export const urls = {
  GET_MASINE_ROBOTE: 'PMProgresProjekata/PMProgresProjekata_VratiMasineRobote',
  GET_PROGRES: 'PMProgresProjekata/PMProgresProjekata_Vrati',
  UPDATE_PROGRES: 'PMProgresProjekata/PMProgresProjekata_U',
  UPDATE_PRIKAZ_KLIJENTU: 'PMProgresProjekata/Masine_U_PrikazPodatakaKlijentu',
  DELETE_DOKUMENT: 'PMProgresProjekata/PMProgresProjekataDokumenti_U_Obrisano',
  INSERT_DOKUMENT: 'PMProgresProjekata/PMProgresProjekataDokumenti_I',
  GET_DOKUMENTI: 'PMProgresProjekata/PMProgresProjekataDokumenti_Vrati',
};
